import React from "react";
import "./LoadingSpinner.scss";

const LoadingSpinner = props => (
	<div className="loader-spinner mt-5">
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
	</div>
);
export default LoadingSpinner;
